import createjs from 'createjs-collection';

export function customizer(v) {
  if (typeof v === 'object' && v !== null && (v._isVue || v instanceof createjs.Stage)) return v;
}

export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
